<template>
  <DisabledTooltip
    v-if="showMenu"
    :tooltip_text="$t('Tenders.NoActiveOffersTender')">
    <template #activator>
      <MenuItem
        v-if="list"
        class="h11-links"
        data-qa="item-download-comparison-table"
        :disabled="loading"
        icon="download"
        :label="$t('Tenders.DownloadComparisonTable')"
        @click="getComparisonTable"/>
      <sButton
        v-else
        color="var(--white-color)"
        data-qa="btn-download-comparison-table"
        :disabled="loading"
        icon="download"
        :rounded="false"
        type="text"
        @click="getComparisonTable">
        {{ $t('Tenders.DownloadComparisonTable') }}
      </sButton>
    </template>
  </DisabledTooltip>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import DisabledTooltip from 'components/common/elements/DisabledTooltip.vue'

import { mapGetters } from 'vuex'

/**
 * Загрузка сравнительной таблицы
 */
export default {
  name: 'downloadComparisonTable',
  data() {
    return {
      loading: false
    }
  },
  props: {
    tender: Object,
    list: Boolean,
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
    }),
    status() {
      return this.tender.tenderStatus?.id || this.tender.tenderStatusId
    },
    showMenu() {
      if (this.status === this.statuseKeys.REGISTRY) {
        return false
      }
      // на приеме и аукционе при скрытии предложений не отображаем
      if ([this.statuseKeys.SUBMISSION, this.statuseKeys.AUCTION].includes(this.status) && this.settings.tenderSettings.hideProposalsUntilRemoveTenderFromSite) {
        return false
      }
      return true
    }
  },
  methods: {
    async getComparisonTable() {
      this.loading = true
      const report = {
        id: null,
        title: `${this.$t('Tenders.ComparativeTable')} #${this.tender.tenderNumber}`
      }
      const key = `comparisonTable${this.tender.tenderId}`
      this.$notifier.generateReportFile(report, this.tender.tenderId, key)
      this.loading = false
      return
    },
  },
  components: {
    MenuItem,
    DisabledTooltip
  }
}
</script>
